import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { evaluationFormList } from "../../../../../../../services/evaluationForm.service";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";
import { TMessageForm } from "./messageSchema";
import { listMainGenerics } from "../../../../../../../services/generic.service";
import { useWatch } from "react-hook-form";

const translationPath = "components.messages.";

export const SelectEvaluationForm = memo(() => {
  const { t } = useTranslation();

  const { automation } = useAutomationRules();

  const { setValue, control } = useFormContext<TMessageForm>();

  const activeServiceSearchSurveyType = useWatch({
    control,
    name: "activeServiceSearchSurveyType",
  });

  const [options, setOptions] = useState<ISelectType[]>([]);

  const { sendRequest } = useFetch(evaluationFormList);

  const isActiveServiceSearch = ["27", "35"].includes(String(automation?.code));

  const fetchEvaluationForm = useCallback(async () => {
    const { data, success } = await sendRequest({
      FormTypeCodes: isActiveServiceSearch ? ["4"] : ["1"],
    });
    if (data && success) {
      setOptions(data.map((d) => ({ id: d.id, name: d.title })));
    }
  }, [isActiveServiceSearch, sendRequest]);

  useEffect(() => {
    fetchEvaluationForm();
  }, [fetchEvaluationForm]);

  useEffect(() => {
    setValue("ticketAutomation", automation);
  }, [setValue, automation]);

  const hasSurveyType =
    !!activeServiceSearchSurveyType && !!activeServiceSearchSurveyType.code;
  const surveyCode = String(activeServiceSearchSurveyType?.code ?? "");

  if (automation && !automation.allowForm) return null;

  return (
    <>
      {isActiveServiceSearch && (
        <Grid item xs={12} sm={5}>
          <AutoComplete
            getOptionLabel={({ name }) => name}
            size="small"
            label={t(translationPath + "active_service_search_survey_type")}
            name="activeServiceSearchSurveyType"
            request={listMainGenerics}
            params={{ Identifier: "ActiveServiceSearchSurveyType" }}
          />
        </Grid>
      )}

      {((isActiveServiceSearch && hasSurveyType && surveyCode === "1") ||
        (!isActiveServiceSearch && (!hasSurveyType || surveyCode === "1"))) && (
        <Grid item xs={12} sm={isActiveServiceSearch ? 5 : 10}>
          <AutoComplete
            name="evaluationForm"
            label={t(translationPath + "evaluation_form")}
            getOptionLabel={(option) => option.name}
            size="small"
            fullWidth
            options={options}
          />
        </Grid>
      )}

      {((isActiveServiceSearch && hasSurveyType && surveyCode === "2") ||
        (!isActiveServiceSearch && surveyCode === "2")) && (
        <Grid item xs={12} sm={5}>
          <Typography variant="body2" color="text.secondary">
            {t(translationPath + "evaluation_link_same_as_template") ||
              "O link de avaliação será o mesmo cadastrado no template."}
          </Typography>
        </Grid>
      )}
    </>
  );
});
